import type { BusinessRecord, MetricItem } from '@/types/business'

const regions = ['南宁市（模拟）','柳州市（模拟）','桂林市（模拟）','梧州市（模拟）']
const categories = ['粮油种植','特色果蔬','畜禽养殖','农产品加工']
const states = ['待处理','服务中','已完成','需复核']

export const records: BusinessRecord[] = Array.from({ length: 48 }, (_, index) => ({
  id: `mock-${index + 1}`,
  code: `GX-DEMO-${String(index + 1).padStart(4, '0')}`,
  name: `示例业务对象 ${String(index + 1).padStart(2, '0')}`,
  category: categories[index % categories.length],
  region: regions[index % regions.length],
  owner: `演示责任人 ${index % 6 + 1}`,
  updatedAt: `2026-08-${String(25 - (index % 18)).padStart(2, '0')} ${String(9 + index % 8).padStart(2, '0')}:20`,
  status: states[index % states.length],
  priority: ['普通','关注','紧急'][index % 3],
  progress: 28 + (index * 13) % 72
}))

export const dashboardMetrics: MetricItem[] = [
  { label:'服务覆盖率', value:'86.4%', change:'较上月 +4.2%', tone:'green' },
  { label:'本月服务次数', value:'1,286', change:'目标完成 78%', tone:'blue' },
  { label:'待处理工单', value:'36', change:'其中紧急 4 件', tone:'amber' },
  { label:'服务满意度', value:'96.8%', change:'有效评价 842 条', tone:'green' }
]

export const todoItems = [
  { title:'确认 4 条紧急服务需求', meta:'训后服务 · 30 分钟内', level:'紧急' },
  { title:'复核本周现场服务纪要', meta:'专家服务 · 12 条', level:'待复核' },
  { title:'处理服务覆盖率黄色预警', meta:'监管绩效 · 2 个示例县', level:'预警' },
  { title:'审核政策库更新草稿', meta:'政策服务 · 7 条', level:'普通' }
]

export const industryStats = [62, 78, 55, 88, 73, 91, 82, 96]
